module.exports = __webpack_public_path__ + "img/20210306-65.0162f098.jpg";